export class MrtAxiosException<T = unknown> extends Error {
  code?: string;
  data?: T;
  isMrtError?: boolean;

  constructor(params: { code?: string; message?: string; data?: T; isMrtError?: boolean } = {}) {
    super(params.message || 'Request failed');
    this.name = 'MrtAxiosException';
    this.code = params.code;
    this.data = params.data;
    this.isMrtError = params.isMrtError ?? true;
  }
}
